
<script>
  import Accordion from '../components/Accordion.svelte'
  import Chart from '../charts/TVvsDigital.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'

</script>
<section class="part4">
  <div class="rgrid-md-1-2 chart-wrap">
    <div class="col col1">
      <AnimatedTitle class="medium title1" style="maskup">Meanwhile, traditional linear TV has proved it’s here to stay.</AnimatedTitle>
      <AnimatedTitle class="accent title2">In 2020, time spent viewing traditional linear TV remained steady year-over-year and remains high compared to digital video.</AnimatedTitle>
    </div>
    <div class="col">
      <div class="title-wrap"><AnimatedBlock><h4>TV vs. Digital: Average Time Spent in the US, 2018-2022</h4></AnimatedBlock></div>
      <Accordion expandedOnDesktop={true} id="avg_time_spent">
        <Chart />
      </Accordion>
    </div>
  </div>
</section>

<style>
  .part4 {
    margin-top: 8rem;
  }
  .part4 :global(.anim-title .title1) {
    margin-bottom: 2.75rem;
  }
  .part4 :global(.anim-title .title2) {
    margin-bottom: 4.375rem;
  }
  @media(max-width: 767px) {
    .chart-wrap .title-wrap {
      display: none;
    }
  }
  @media(min-width: 768px) {
    .chart-wrap :global(.accordion .title) {
      display: none;
    }
  }
</style>